import { render, staticRenderFns } from "./postHeader.vue?vue&type=template&id=cff345ac&lang=pug&"
import script from "./postHeader.vue?vue&type=script&lang=js&"
export * from "./postHeader.vue?vue&type=script&lang=js&"
import style0 from "./postHeader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "postHeader.vue"
export default component.exports